import { ReactNode, RefObject, useState } from "react";
import "./LabelInput.css";

interface LabelInputProps {
  id?: string;
  label?: string;
  value: string;
  type: string;
  placeholder?: string;
  error?: string;
  onChangeText: (text: string) => void;
  inputRef?: RefObject<HTMLInputElement>;
  onclickValue?: () => void;
  inputMainContainer?: string;
  rightComponent?: ReactNode;
  leftComponent?: ReactNode;
  isErrorShow?: boolean;
  onkeydown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  inputContainerClassName?: string;
  inputStyleClassName?: string;
  labelStyleClasssName?: string;
  disabled?: boolean;
  maxLength?: number;
}
const LabelInput = ({
  id,
  label,
  value,
  type,
  placeholder,
  onChangeText,
  inputRef,
  onclickValue,
  error,
  inputMainContainer,
  rightComponent,
  leftComponent,
  isErrorShow,
  onkeydown,
  inputContainerClassName,
  inputStyleClassName,
  labelStyleClasssName,
  disabled,
  maxLength,
}: LabelInputProps) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleOnFocus = () => {
    setIsFocused(!isFocused);
  };

  const handleBlur = () => {
    setIsFocused(!isFocused);
  };

  return (
    <div className={`mainContainer ${inputMainContainer}`}>
      {label && (
        <p className={`headingBlueColor inputLabel ${labelStyleClasssName}`}>
          {label}
        </p>
      )}
      {/*headingBlueColor is in App.css*/}
      <div
        className={`inputContainer ${inputContainerClassName}`}
        style={{
          border: isFocused ? "1px solid #014792" : "1px solid #ededed",
          backgroundColor: disabled ? "#d8dbe0" : "transparent",
        }}
      >
        {leftComponent && leftComponent}
        <input
          id={id}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChangeText(e.target.value)}
          ref={inputRef}
          onClick={onclickValue}
          className={`inputStyle ${inputStyleClassName}`}
          type={type}
          onFocus={handleOnFocus}
          onBlur={handleBlur}
          onKeyDown={onkeydown}
          disabled={disabled}
          maxLength={maxLength}
          style={{ backgroundColor: disabled ? "#d8dbe0" : "transparent" }}
        />
        {rightComponent && rightComponent}
      </div>
      {isErrorShow !== true && <p className="error">{error || "\u00A0"}</p>}
    </div>
  );
};

export default LabelInput;
